import { searchService } from 'services';

export const getServerSidePropsNewsListPage: GetServerSideProps = async (
  context,
) => {
  const terminal = context.req.tenantEnv.terminal;
  const query = context.query;
  const { news, totalItems } = await searchService.getNewsFeed(
    terminal,
    undefined,
    Number(query.page),
  );
  if (!news) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      news,
      totalItems,
    },
  };
};

export const getServerSidePropsNewsPage: GetServerSideProps = async (
  context,
) => {
  const terminalCode = context.req.tenantEnv.terminal;
  const newsFeed = await searchService.getNewsFeed(
    terminalCode,
    context.query.slug as string,
  );
  if (newsFeed.totalItems === 0) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      news: newsFeed.news?.[0] || {},
    },
  };
};

export const stripHtmlString = (html: string) =>
  html.replace(/(<([^>]+)>)/gi, '');
